import React, { useEffect, useState } from 'react';
import 'react-phone-number-input/style.css';
import PhoneInput, { getCountryCallingCode } from 'react-phone-number-input';
import { InputFeedback } from '../UI/TextField';
import classNames from 'classnames';

const CountryCodePickerInput = ({ value, onChange, onBlur, error, className }) => {
  const [phone, setPhone] = useState();
  const [countryCode, setCountryCode] = useState('');

  const handleChange = (e) => {
    console.log(e, countryCode);
    setPhone(e);
    onChange(e, countryCode);
  };

  const InputClasses = classNames(
    'country-input',
    {
      'is-invalid': !!error,
    },
    className,
  );

  useEffect(() => {
    if (value) setPhone(value);
  }, [value]);

  useEffect(() => {
    setCountryCode(`+${getCountryCallingCode('NG')}`);
  }, []);

  useEffect(() => {
    setPhone();
    onChange('', countryCode);
  }, [countryCode]);

  return (
    <div>
      <PhoneInput
        placeholder="Enter Phone Number"
        value={phone}
        onChange={handleChange}
        onCountryChange={(v) => setCountryCode(`+${getCountryCallingCode(v)}`)}
        onBlur={onBlur}
        className={InputClasses}
        defaultCountry="NG"
      />
      <InputFeedback error={error} />
    </div>
  );
};

export default CountryCodePickerInput;
